import { Grid } from "@mui/material";
import React from "react";
import Bouton from "../../../../components/Button/Bouton";
import UncontrolledInputField from "../../../../components/input/UncontrolledInputField";
import InputCheckbox from "../../../../components/inputCheckbox/InputCheckbox";

interface Props {
  classes?: any; // Surcharge de style CSS injecté par withStyles
  onChangeCritere(critere: string | number, value: string | boolean): void;
  onRechercher(): void;
  initialValues: { [key: string]: any };
  utilisateurBesse?: boolean;
  idAdb?: number;
  isChargeClienteleBesse?: boolean;
}

function CriteresRecherche({
  idAdb,
  utilisateurBesse,
  isChargeClienteleBesse,
  onChangeCritere,
  onRechercher,
  initialValues,
}: Props) {
  const handleUpdateCritere = (id: string | number, value: string) => {
    onChangeCritere(id, value);
  };

  const handleUpdateCritereCheckBox = (id: string | number, event: boolean) => {
    onChangeCritere(id, event);
  };
  /**
   * Fonction permettant de déclencher la recherche.
   */
  const handleRechercher = () => {
    onRechercher();
  };

  return (
    <React.Fragment>
      <section>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          className={"formRechercherAdb fondGrisFonce"}
        >
          <Grid item xs={3}>
            <UncontrolledInputField
              id="nom"
              label="Nom"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            <UncontrolledInputField
              id="prenom"
              label="Prénom"
              handleChange={handleUpdateCritere}
            />
          </Grid>
          <Grid item xs={3}>
            {/* on l'affiche seulement si idAdb existe OU pas utilisateur Besse */}
            {(idAdb || !utilisateurBesse) && (
              <UncontrolledInputField
                id="fonction"
                label="Fonction"
                handleChange={handleUpdateCritere}
              />
            )}
          </Grid>
          <Grid item xs={3} />
          <Grid item xs={3}>
            <InputCheckbox
              input={{
                name: "statut",
                onBlur: () => {},
                onChange: () => {},
                onFocus: () => {},
                value: initialValues.statut,
              }}
              meta={{}}
              id="statut"
              name="statut"
              value={initialValues.statut}
              label="Actif"
              onChangeValue={handleUpdateCritereCheckBox}
            />
          </Grid>
          <Grid item xs={3}>
            {/* on affiche seulement si utilisateur Besse ET IdAdb existe et il n'est pas chargé de clientèle besse  */}
            {idAdb && utilisateurBesse && !isChargeClienteleBesse && (
              <InputCheckbox
                input={{
                  name: "profilBesse",
                  onBlur: () => {},
                  onChange: () => {},
                  onFocus: () => {},
                  value: initialValues.profilBesse,
                }}
                meta={{}}
                id="profilBesse"
                name="profilBesse"
                value={initialValues.profilBesse}
                label="Profil Bessé"
                onChangeValue={handleUpdateCritereCheckBox}
              />
            )}
          </Grid>
          <Grid item className={"bouton"} xs={6}>
            <Bouton
              label="Rechercher"
              variant="contained"
              color="primary"
              size="medium"
              onClick={handleRechercher}
            />
          </Grid>
        </Grid>
      </section>
    </React.Fragment>
  );
}

export default CriteresRecherche;
